// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IAccountStatusDto } from './IAccountStatusDto';
import {
    IAccountStatusDtoFromJSON,
    IAccountStatusDtoFromJSONTyped,
    IAccountStatusDtoToJSON,
    IAccountStatusDtoToJSONTyped,
} from './IAccountStatusDto';

/**
 * 
 * @export
 * @interface IAccountVerificationStatusResponseDto
 */
export interface IAccountVerificationStatusResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IAccountVerificationStatusResponseDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IAccountVerificationStatusResponseDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof IAccountVerificationStatusResponseDto
     */
    external_identifier?: string;
    /**
     * 
     * @type {number}
     * @memberof IAccountVerificationStatusResponseDto
     */
    available_balance?: number;
    /**
     * 
     * @type {number}
     * @memberof IAccountVerificationStatusResponseDto
     */
    on_deposit_balance?: number;
    /**
     * 
     * @type {number}
     * @memberof IAccountVerificationStatusResponseDto
     */
    live_balance?: number;
    /**
     * 
     * @type {number}
     * @memberof IAccountVerificationStatusResponseDto
     */
    parent_account_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof IAccountVerificationStatusResponseDto
     */
    created_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IAccountVerificationStatusResponseDto
     */
    modified_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof IAccountVerificationStatusResponseDto
     */
    account_type?: IAccountVerificationStatusResponseDtoAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IAccountVerificationStatusResponseDto
     */
    account_category?: IAccountVerificationStatusResponseDtoAccountCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof IAccountVerificationStatusResponseDto
     */
    routing_transit_number?: string;
    /**
     * 
     * @type {number}
     * @memberof IAccountVerificationStatusResponseDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IAccountVerificationStatusResponseDto
     */
    organization_path?: string;
    /**
     * 
     * @type {number}
     * @memberof IAccountVerificationStatusResponseDto
     */
    number_length?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IAccountVerificationStatusResponseDto
     */
    leaf_node?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IAccountVerificationStatusResponseDto
     */
    employee_id?: number;
    /**
     * 
     * @type {IAccountStatusDto}
     * @memberof IAccountVerificationStatusResponseDto
     */
    account_status?: IAccountStatusDto;
    /**
     * 
     * @type {string}
     * @memberof IAccountVerificationStatusResponseDto
     */
    account_number_last4?: string;
    /**
     * 
     * @type {string}
     * @memberof IAccountVerificationStatusResponseDto
     */
    verification_status?: IAccountVerificationStatusResponseDtoVerificationStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum IAccountVerificationStatusResponseDtoAccountTypeEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}
/**
* @export
* @enum {string}
*/
export enum IAccountVerificationStatusResponseDtoAccountCategoryEnum {
    CHECKING = 'CHECKING',
    SAVING = 'SAVING',
    NONE = 'NONE'
}
/**
* @export
* @enum {string}
*/
export enum IAccountVerificationStatusResponseDtoVerificationStatusEnum {
    PENDING = 'PENDING',
    PENDING_MANUAL = 'PENDING_MANUAL',
    VERIFIED = 'VERIFIED',
    VERIFICATION_FAILED = 'VERIFICATION_FAILED',
    EXPIRED = 'EXPIRED'
}


/**
 * Check if a given object implements the IAccountVerificationStatusResponseDto interface.
 */
export function instanceOfIAccountVerificationStatusResponseDto(value: object): value is IAccountVerificationStatusResponseDto {
    return true;
}

export function IAccountVerificationStatusResponseDtoFromJSON(json: any): IAccountVerificationStatusResponseDto {
    return IAccountVerificationStatusResponseDtoFromJSONTyped(json, false);
}

export function IAccountVerificationStatusResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAccountVerificationStatusResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'description': json['description'] == null ? undefined : json['description'],
        'external_identifier': json['external_identifier'] == null ? undefined : json['external_identifier'],
        'available_balance': json['available_balance'] == null ? undefined : json['available_balance'],
        'on_deposit_balance': json['on_deposit_balance'] == null ? undefined : json['on_deposit_balance'],
        'live_balance': json['live_balance'] == null ? undefined : json['live_balance'],
        'parent_account_id': json['parent_account_id'] == null ? undefined : json['parent_account_id'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'modified_at': json['modified_at'] == null ? undefined : (new Date(json['modified_at'])),
        'account_type': json['account_type'] == null ? undefined : json['account_type'],
        'account_category': json['account_category'] == null ? undefined : json['account_category'],
        'routing_transit_number': json['routing_transit_number'] == null ? undefined : json['routing_transit_number'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'number_length': json['number_length'] == null ? undefined : json['number_length'],
        'leaf_node': json['leaf_node'] == null ? undefined : json['leaf_node'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'account_status': json['account_status'] == null ? undefined : IAccountStatusDtoFromJSON(json['account_status']),
        'account_number_last4': json['account_number_last4'] == null ? undefined : json['account_number_last4'],
        'verification_status': json['verification_status'] == null ? undefined : json['verification_status'],
    };
}

export function IAccountVerificationStatusResponseDtoToJSON(json: any): IAccountVerificationStatusResponseDto {
    return IAccountVerificationStatusResponseDtoToJSONTyped(json, false);
}

export function IAccountVerificationStatusResponseDtoToJSONTyped(value?: IAccountVerificationStatusResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'description': value['description'],
        'external_identifier': value['external_identifier'],
        'available_balance': value['available_balance'],
        'on_deposit_balance': value['on_deposit_balance'],
        'live_balance': value['live_balance'],
        'parent_account_id': value['parent_account_id'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'modified_at': value['modified_at'] == null ? undefined : ((value['modified_at']).toISOString()),
        'account_type': value['account_type'],
        'account_category': value['account_category'],
        'routing_transit_number': value['routing_transit_number'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'number_length': value['number_length'],
        'leaf_node': value['leaf_node'],
        'employee_id': value['employee_id'],
        'account_status': IAccountStatusDtoToJSON(value['account_status']),
        'account_number_last4': value['account_number_last4'],
        'verification_status': value['verification_status'],
    };
}

